import { senhaSchema } from '@mymaxx/shared';
import { Aviso, Botao, CampoTexto } from '@mymaxx/ui';
import { useState, type FormEvent } from 'react';
import { authApi, ErroApi } from '../lib/api';
import { useSessao } from '../lib/sessao';

/**
 * Troca obrigatória da senha no primeiro acesso.
 *
 * Aparece para o técnico de liberação: a senha dele é entregue pelo admin, e sem esta
 * tela ela viraria a mesma para a equipe inteira. Não tem como pular — é a única coisa
 * que a conta mostra enquanto a senha ainda for a provisória.
 */
export function TrocarSenha() {
  const { cliente, definir, accessToken } = useSessao();
  const [atual, setAtual] = useState('');
  const [nova, setNova] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: FormEvent) {
    e.preventDefault();
    const parse = senhaSchema.safeParse(nova);
    if (!parse.success) return setErro(parse.error.issues[0]?.message ?? 'Senha fraca');
    setErro(null);
    setEnviando(true);
    try {
      await authApi.trocarSenha(atual, parse.data);
      // A sessão atual segue valendo; só o retrato do cliente em memória está velho.
      const atualizado = await authApi.eu();
      if (accessToken) definir({ accessToken, expiraEm: 0, cliente: atualizado });
    } catch (err) {
      setErro(err instanceof ErroApi ? err.mensagem : 'Não consegui trocar a senha.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-6 px-6">
      <div className="space-y-1">
        <h1 className="text-xl font-semibold">Defina sua senha</h1>
        <p className="text-sm text-neutral-600 dark:text-neutral-400">
          {cliente?.nome ? `${cliente.nome}, a ` : 'A '}senha que você recebeu é provisória. Escolha
          uma que só você saiba para continuar.
        </p>
      </div>

      <form className="space-y-4" onSubmit={enviar} noValidate>
        <CampoTexto
          rotulo="Senha que você recebeu"
          type="password"
          autoComplete="current-password"
          autoFocus
          value={atual}
          onChange={(e) => setAtual(e.target.value)}
        />
        <CampoTexto
          rotulo="Nova senha"
          type="password"
          autoComplete="new-password"
          value={nova}
          onChange={(e) => setNova(e.target.value)}
          ajuda="No mínimo 10 caracteres. Não pode ser uma senha já vazada por aí."
        />
        {erro && <Aviso tipo="erro">{erro}</Aviso>}
        <Botao type="submit" className="w-full" carregando={enviando}>
          Salvar e continuar
        </Botao>
      </form>
    </main>
  );
}
